import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const defaultColors = {
  primario: "#0066FF",
  secundario: "#01087A",
  terciario: "#2222E3",
  cuaternario: "#D6E4F9",
  quinto: "#02087A",
  sexto: "#E4F3FF",
  septimo: "#9F0DFF",
};

const useDynamicColors = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const colors = {
    primario: `#${queryParams.get("primario")}` || defaultColors.primario,
    secundario: `#${queryParams.get("secundario")}` || defaultColors.secundario,
    terciario: `#${queryParams.get("terciario")}` || defaultColors.terciario,
    cuaternario:
      `#${queryParams.get("cuaternario")}` || defaultColors.cuaternario,
    quinto: `#${queryParams.get("quinto")}` || defaultColors.quinto,
    sexto: `#${queryParams.get("sexto")}` || defaultColors.sexto,
    septimo: `#${queryParams.get("septimo")}` || defaultColors.septimo,
    url_logo: `${queryParams.get("url_logo") || ""}`,
    url_card: `${queryParams.get("url_card") || ""}`,
  };

  useEffect(() => {
    document.documentElement.style.setProperty("--primario", colors.primario);
    document.documentElement.style.setProperty(
      "--secundario",
      colors.secundario
    );
    document.documentElement.style.setProperty("--terciario", colors.terciario);
    document.documentElement.style.setProperty(
      "--cuaternario",
      colors.cuaternario
    );
    document.documentElement.style.setProperty("--quinto", colors.quinto);
    document.documentElement.style.setProperty("--sexto", colors.sexto);
    document.documentElement.style.setProperty("--septimo", colors.septimo);
  }, [colors]);

  return colors;
};

export default useDynamicColors;
